import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Company } from '@shared/models/data-model';
import { RegistrationService } from '@shared/services/registration.service';

export const companyResolver: ResolveFn<Company> = (route, state) => {
    return inject(RegistrationService).getCompany();
};
